const ru = {
  // Navbar
  nav_features: "Возможности",
  nav_howItWorks: "Как это работает",
  nav_download: "Скачать",
  nav_signIn: "Войти",
  nav_downloadApp: "Скачать приложение",
  nav_partners: "Партнерам",

  // Hero
  hero_badge: "Глобальные платежи · В реальном времени",
  hero_titleAccent: "Ваш идеальный",
  hero_title2: "цифровой кошелёк",
  hero_subtitle: "Отправляйте, получайте и обменивайте деньги мгновенно в 150+ странах. Без границ, молниеносно, полный контроль.",
  hero_downloadFree: "Скачать бесплатно",
  hero_seeHow: "Как это работает",
  hero_activeUsers: "Активных пользователей",
  hero_services: "сервисов",
  hero_appRating: "App Store",
  hero_recentActivity: "Последние операции",
  hero_topUp: "Пополнить",
  hero_send: "Отправить",
  hero_exchange: "Обменять",
  hero_history: "История",
  hero_verifiedSecure: "Проверено и защищено",
  hero_today: "сегодня",
  hero_usdBalance: "Баланс USD",
  hero_eurBalance: "Баланс EUR",
  hero_btc: "BTC",
  hero_kztBalance: "Баланс KZT",
  hero_tx1: "Пополнение сервиса",
  hero_tx2: "Получено от Джона",
  hero_tx3: "EUR → USD",
  hero_tx4: "Получено от Максима",
  hero_minAgo: "2 мин назад",
  hero_hrAgo: "1 ч назад",
  hero_hrsAgo: "3 ч назад",

  // Features
  feat_badge: "Почему BroMoney",
  feat_title1: "Всё что нужно,",
  feat_titleAccent: "ничего лишнего",
  feat_subtitle: "Быстро, безопасно, удобно.",
  feat_instant_title: "Быстрые переводы",
  feat_instant_desc: "От 5 минут до 48 часов — в зависимости от выбранного метода перевода.",
  feat_services_title: "Оплата сервисов",
  feat_services_desc: "Оплачивайте сотни сервисов в один клик — коммунальные платежи, подписки, интернет и многое другое.",
  feat_multicurrency_title: "Мультивалюта и крипто",
  feat_multicurrency_desc: "Криптовалюты в различных блокчейн-сетях, USDT и популярный фиат — всё в одном кошельке.",
  feat_security_title: "Защита",
  feat_security_desc: "Надёжное шифрование транзакций и данных. Ваши средства под защитой 24/7.",
  feat_app_title: "Мобильное приложение",
  feat_app_desc: "Нативные приложения для iOS и Android с полным функционалом кошелька.",
  feat_popular: "Популярное",

  // Usage Flow
  flow_badge: "Как это работает",
  flow_title1: "Готов к работе за",
  flow_titleAccent: "3 простых шага",
  flow_subtitle: "Никаких задержек. Просто лучший способ управлять деньгами.",
  flow_step1_title: "Создайте аккаунт",
  flow_step1_desc: "Зарегистрируйтесь за 2 минуты. Быстрая безбумажная верификация — и кошелёк готов.",
  flow_step2_title: "Храните деньги безопасно",
  flow_step2_desc: "BroMoney — надёжное цифровое хранилище. Пополните кошелёк выводом из другого сервиса и держите средства под контролем в любой момент.",
  flow_step3_title: "Отправляйте и платите",
  flow_step3_desc: "Переводите, конвертируйте валюты и оплачивайте сервисы — быстро и без лишних шагов.",
  flow_avgSetup: "Среднее время регистрации:",
  flow_2min: "2 минуты",
  flow_support: "Поддержка",
  flow_supportTime: "с 11 до 02:00 (GMT+5)",
  flow_fundProtected: "Средства застрахованы до",

  // Personal/Business
  pb_badge: "Для партнёров",
  pb_title1: "Бизнес и партнёрство",
  pb_titleAccent: "Мощный для бизнеса.",
  pb_subtitle: "Хотите отправить деньги за рубеж или управлять глобальным магазином — BroMoney масштабируется вместе с вами.",
  pb_personal_title: "Личный",
  pb_personal_sub: "Для обычных пользователей",
  pb_personal_tag: "Для вас",
  perk_send: "Переводите деньги друзьям и семье за секунды",
  perk_exchange: "Обменивайте валюты по межбанковскому курсу",
  perk_app: "Красивое мобильное приложение для iOS и Android",
  perk_history: "Полная история транзакций и аналитика расходов",
  perk_card: "Виртуальная и физическая дебетовая карта включена",
  perk_security: "Средства защищены системой безопасности мирового класса",
  pb_downloadApp: "Скачать приложение",
  pb_business_title: "Бизнес",
  pb_business_sub: "Для продавцов и компаний",
  bperk1: "Принимайте платежи из 150+ стран мгновенно",
  bperk2: "Мощный API и готовые интеграции чекаута",
  bperk3: "Панель бизнес-аналитики в реальном времени",
  bperk4: "Мультипользовательские роли и командные права",
  bperk5: "Инструменты для регулярных платежей и подписок",
  bperk6: "Выделенный менеджер аккаунта и приоритетная поддержка",
  pb_contactBusiness: "Написать нам по бизнесу",
  pb_reviews_title: "Что говорят наши пользователи",
  pb_reviews_rating: "4,9 из 5 · более 2 400 отзывов",
  review1_text: "Отличный кошелёк — быстро вывожу и в крипте, и в фиате. Курсы выгодные, давно не видел таких условий. Рекомендую всем, кто работает с международными переводами.",
  review2_text: "Интерфейс чистый и интуитивный, сразу понятно. Поддержка отвечает быстро и по делу. Использую каждый день — очень удобно.",
  review3_text: "Оплата сервисов — просто огонь. Удобно хранить деньги, переводить на нужные аккаунты когда нужно. Безопасно и настоящее спасение.",

  // CTA
  cta_badge: "Начните сегодня — Это бесплатно",
  cta_title1: "Ваши деньги,",
  cta_title2: "всегда с вами",
  cta_subtitle: "Присоединяйтесь к тысячам пользователей, которые доверяют BroMoney быстрые, безопасные и безграничные платежи.",
  cta_downloadOn: "Скачать в",
  cta_appStore: "App Store",
  cta_downloadApk: "Скачать для",
  cta_android: "Android",
  cta_getItOn: "Получить в",
  cta_googlePlay: "Google Play",
  cta_rating: "Рейтинг 4.9 в App Store",
  cta_bankSecurity: "Защита банковского уровня",
  cta_noHidden: "Без скрытых платежей",
  cta_account: "Личный кабинет",

  // Footer
  footer_desc: "Ваш идеальный цифровой кошелёк для мгновенных глобальных платежей, переводов и обмена.",
  footer_goToWallet: "Перейти в кошелёк",
  footer_downloadAppStore: "Скачать в App Store",
  footer_downloadApk: "Скачать APK",
  footer_downloadGooglePlay: "Скачать APK (Google Play)",
  footer_copyright: "BroMoney. Все права защищены.",
  footer_regulated: "BroMoney регулируется директивой ЕС PSD2. Лицензировано FCA.",
  footer_privacy: "Политика конфиденциальности",
  footer_terms: "Пользовательское соглашение",

  // Language names
  lang_ru: "Русский",
  lang_kk: "Қазақша",
  lang_uz: "O'zbekcha",
  lang_en: "English",
};

export default ru;
